import * as React from "react";
import SettingsContainer from "./settings.container";
import DetailSelectedContainer from "./detailSelected.container";
import ContactContainer from "./contact.container";
import CotizacionContainer from "./cotizacion.container";

declare const window: any;

export default function TopBarContainer({
  subMenuSelected,
  menuSelected,
  setMenuSelected,
  setSubMenuSelected,
  colors,
  theme,
  active,
  setIsTheme,
  setFrame,
  setShow,
  show,
  setShowTextHotspots,
  showTextHotspots,
  isPortrait,
  isContactBtn,
  setIsContactModal,
  isLoading,
  setIsCotizacion,
  cotizacion,
  isCotizacion,
  properties
}: any) {
  const [animationIntro, setAnimationIntro] = React.useState(false);
  React.useEffect(() => {
    setAnimationIntro(false);
    setTimeout(() => {
      setAnimationIntro(true);
    }, 500);
  }, [active]);

  return (
    <div
      className={`top-bar-container ${
        animationIntro ? active + " animation" : active
      }`}
    >
      {menuSelected === "Inmuebles" && subMenuSelected !== "" ? (
        <DetailSelectedContainer
          detail={subMenuSelected}
          setMenuSelected={setMenuSelected}
          setSubMenuSelected={setSubMenuSelected}
          theme={theme}
          colors={colors}
          setIsTheme={setIsTheme}
          setFrame={setFrame}
          properties={properties}
        />
      ) : null}
      {cotizacion ? (
        <CotizacionContainer
          colors={colors}
          setIsCotizacion={setIsCotizacion}
          isCotizacion={isCotizacion}
          theme={theme}
        />
      ) : null}
      {isContactBtn ? (
        <ContactContainer
          colors={colors}
          setIsContactModal={setIsContactModal}
          isContactBtn={isContactBtn}
        />
      ) : null}
      {isContactBtn ? (
        <ContactContainer
          colors={colors}
          setIsContactModal={setIsContactModal}
          isContactBtn={isContactBtn}
        />
      ) : null}
      <SettingsContainer
        theme={theme}
        colors={colors}
        setIsTheme={setIsTheme}
        menuSelected={menuSelected}
        setShow={setShow}
        show={show}
        setShowTextHotspots={setShowTextHotspots}
        showTextHotspots={showTextHotspots}
        animationIntro={animationIntro}
        isPortrait={isPortrait}
      />
    </div>
  );
}
